import React, { MouseEvent, ReactNode } from 'react';
import Link from '@/providers/Link';
import { BreadcrumbItem, BreadcrumbList, Element } from './Breadcrumb.styles';

export type BreadcrumItemType = {
  path?: string;
  text: string;
};

export interface BreadcrumbProps {
  items: BreadcrumItemType[];
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const Breadcrumb = ({ items, children, ...props }: BreadcrumbProps) => {
  return (
    <Element aria-label="breadcrumb">
      <BreadcrumbList>
        <BreadcrumbItem>
          <Link href="/">Home</Link>
        </BreadcrumbItem>
        {items?.length &&
          items.map((item, index) =>
            items.length - 1 > index ? (
              <BreadcrumbItem key={`${item.path}-${index}`}>
                <Link href={item.path as string}>{item.text}</Link>
              </BreadcrumbItem>
            ) : (
              <BreadcrumbItem key={`${item.path}-${index}`} aria-current="page">
                {item.text}
              </BreadcrumbItem>
            )
          )}
      </BreadcrumbList>
    </Element>
  );
};

export default Breadcrumb;
